import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

/**
 * Choix de l'utilisateur au moment d'enregistrer un terrain.
 * replaceIndex vaut null quand il ajoute une version plutôt que d'en écraser une.
 */
export interface SaveTerrainChoice {
  replaceIndex: number | null;
}

@Component({
  selector: 'app-save-terrain-modal',
  standalone: true,
  imports: [CommonModule, TranslateModule, FormsModule],
  templateUrl: './save-terrain-modal.component.html',
  styleUrls: ['./save-terrain-modal.component.scss'],
  // Tout change depuis ses propres contrôles (radios, boutons) : OnPush suffit.
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SaveTerrainModalComponent {
  /** Émis uniquement sur confirmation : une fermeture sans choix n'enregistre rien. */
  readonly onConfirm = new Subject<SaveTerrainChoice>();

  /** Versions déjà enregistrées, dans l'ordre du proto. Renseigné par initialState. */
  existingVersions: string[] = [];

  /**
   * Sentinelle de l'option « ajouter ». Un null passerait par RadioControlValueAccessor, qui
   * résout la valeur de façon asynchrone : la comparaison stricte du template deviendrait
   * fragile. Une chaîne est comparée sans ambiguïté.
   */
  readonly APPEND = 'append';

  /** 'append' pour ajouter à la liste ; sinon rang de la version à remplacer. */
  selection: number | string = this.APPEND;

  constructor(private readonly modalRef: BsModalRef) {}

  confirm(): void {
    this.onConfirm.next({ replaceIndex: this.selection === this.APPEND ? null : Number(this.selection) });
    this.modalRef.hide();
  }

  cancel(): void {
    this.modalRef.hide();
  }
}
